// pages/UsersPage.jsx
import React, { useState } from "react";
import { manageUsersTableCols } from "./cols";
import ExpandableTable from "../Components/expandAbleTable";
import UsersSection from "../ManageProjectsPermissionsTab/UsersSection";
import { getAllUsers } from "./api";

export default function UsersPage() {
  const [users, setUsers] = useState([]);

  React.useEffect(() => {
    const getAllData = async () => {
      const data = await getAllUsers();
      if (data) setUsers(data);
    };
    getAllData();
  }, []);

  return (
    <ExpandableTable
      entityName="Member"
      tableTitle="Staff Management"
      data={users}
      setData={setUsers}
      cols={manageUsersTableCols}
      subSection={<UsersSection />}
      expand={false}
      addNewBtn={true}
    />
  );
}
